import { useTheme } from "app/shared";

import styles from "./dashboard-buttons.module.scss";

const DashboardButtons = () => {
  const { theme } = useTheme();

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>Personal Dashboard</h1>
      {/* <div className={styles.btnWrapper}>
				<Button
					className={styles.btn}
					icon={<Linea />} >
					Linea
				</Button>
				<Button
					disabled
					className={styles.btn}
					icon={<Fire />} >
					5ire
				</Button>
				<Button
					disabled
					className={styles.btn}
					icon={<Taiko />} >
					Taiko
				</Button>
				<Button
					disabled
					className={styles.btn}
					icon={<Metis />} >
					Metis
				</Button>
			</div>
			<div className={styles.textWrapper}>
				<h3 className={`${styles.text} ${theme === 'dark' && styles.darkTheme}`}>Coming Soon</h3>
			</div> */}
    </div>
  );
};

export default DashboardButtons;
